﻿import { Button, Modal } from "antd";
import HistoryLogTable from "@/components/History/HistoryLogTable";

interface IProps {
    open: boolean;
    onClose: () => void;
    projectIssueId: string | undefined;
}

export const IssueHistoryModal = ({projectIssueId, open, onClose}: IProps) => {
    if (projectIssueId === undefined) {
        return null;
    }
    return (
        <Modal
            open={open}
            title={"Issue History"}
            onCancel={onClose}
            style={{ minWidth: "50%" }}
            footer={[
                <Button onClick={onClose}>
                    Close
                </Button>]}
            >
            <HistoryLogTable parentEntityId={projectIssueId} pageSize={10} />
        </Modal>
    )
}